<template>
<div class="_container _light">
	<div class="_insideContainer">
		<Title :title="title" :tag="head" type="light"/>
		<div class="aimsContainer" v-for="(item, index) in aimList" :key="index" data-aos="fade-right">
			<div class="_number">{{ index + 1 }}</div>
			<div class="_content">{{ item }}</div>
		</div>
	</div>
</div>
</template>

<script>
import Title from '../common/Title.vue'
export default {
	props: { head: String, title: String, data: Object },
	components: { Title },
	computed: { aimList() { return this.data.hedefler ? this.data.hedefler.split('\n').filter(p => p.trim() !== '') : []; } }
}
</script>

<style scoped>
._container { width: 100%; display: flex; justify-content: center; padding: 100px 5%; background-color: white;}
._insideContainer { width: 100%; max-width: 1900px; }
.aimsContainer{ display: flex; align-items: flex-start; font-family: 'DM Sans', sans-serif; color: black; margin-bottom: 30px; }
.aimsContainer ._number{ display: flex; justify-content: center; align-items: center; border: 1px solid black; border-radius: 100px; min-width: 25px; min-height: 25px; margin-right: 15px; font-size: 14px; }
.aimsContainer ._content{ font-size: 18px; font-weight: 400; line-height:1.6;}
@media screen and (max-width: 1023px){ .aimsContainer ._content{ font-size: 15px; } }
</style>